import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

export interface Team {
  id: string;
  name: string;
  image: string;
  title: string;
  faq: Faq[];
}
export interface Faq {
  q: string;
  a: string;
}

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss'],
})
export class TeamComponent implements OnInit {
  @Input() count = 0;
  order: number | null = null;

  constructor(private router: Router, private route: ActivatedRoute) {
    if (!this.count) {
      this.count = this.team.length;
    }
    this.team = this.shuffle(this.team);
  }

  ngOnInit(): void {
    this.route.fragment.subscribe((f) => {
      let id = this.findBio(f);
      if (id !== -1) this.showBio(id);
    });
  }
  findBio(f: any) {
    return this.team.findIndex((x) => x.id === f);
  }

  isDisabled(order: number): boolean {
    if (this.order !== order) return true;
    return false;
  }
  closeBio(): void {
    this.order = null;
  }
  showBio(order: number): void {
    this.order = order;
  }

  shuffle(array: Team[]): Team[] {
    let currentIndex = array.length,
      randomIndex;

    while (currentIndex != 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex],
        array[currentIndex],
      ];
    }

    return array;
  }

  team: Team[] = [
    {
      image: '/assets/images/team/julie-lee.jpg',
      id: 'julie-lee',
      name: 'Julie Claflin-Lee',
      title: 'Catering Manager ',
      faq: [
        {
          q: 'What type of events do you enjoy working?',
          a: 'Large outdoor events and catered social events where everyone is there to have a good time.',
        },
        {
          q: 'What do you like about working for M|Catering?',
          a: 'I love that every day is different and requires a lot of creative thinking.',
        },
        {
          q: 'How do you feel about your customers?',
          a: 'I want our customers to enjoy the experience of working with M|Catering from start to finish.',
        },
        {
          q: 'Describe a time when you went above and beyond for a customer/event?',
          a: 'There are too many to count! It is our job to do everything we can to make the guests’ experience as seamless as possible and help alleviate any stress they may have about the catered portion of their event.',
        },
        {
          q: "What's your favorite thing about your job?",
          a: 'Working with students.',
        },
        {
          q: 'How is M|Catering different or special?',
          a: 'All of the M|Catering teams are some of the most adaptable, creative and fun-loving people you will ever work with.',
        },
      ],
    },
    {
      image: '/assets/images/team/lindsay-sullivan.jpg',
      id: 'lindsay-sullivan',
      name: 'Lindsay Sullivan',
      title: 'Assistant Catering Manager',
      faq: [
        {
          q: 'What type of events do you enjoy working?',
          a: 'I really enjoy working events in unique locations. Our campus has so many great places to entertain guests. Some of my favorite places to cater are the Matthei Botanical Gardens and University of Michigan Museum of Art.',
        },
        {
          q: 'What do you like about working for M|Catering?',
          a: 'My favorite things about working in catering are the fast pace and the dynamic nature of the business.',
        },
        {
          q: 'How is M|Catering different or special?',
          a: 'Our skilled professional team and our student employees make us special.',
        },
        {
          q: 'How do you feel about your customers?',
          a: 'After so many years, I have built great working relationships with many of our university customers. l always look forward to seeing regular clients and providing great service for them.',
        },
        {
          q: 'Describe a time when you went above and beyond for a customer/event.',
          a: 'There are a lot of details and moving pieces to consider in the execution of each event, so a job well done is very gratifying. My goal is always to exceed the expectations.',
        },
      ],
    },
    {
      image: '/assets/images/team/jay-davis.jpg',
      id: 'jay-davis',
      name: 'Jay Davis',
      title: 'Assistant Catering Manager',
      faq: [
        {
          q: 'What type of events do you enjoy working?',
          a: 'I enjoy working a variety of events ranging from large to small and everything in between.',
        },
        {
          q: 'What do you like about working for M|Catering?',
          a: 'I like the overall environment! I enjoy the teamwork and focused efforts toward making every event the best it can be. I love customer satisfaction!',
        },
        {
          q: 'Tell us about the team.',
          a: 'We work together to accomplish common goals and make events special. We collaborate and plan to ensure successful outcomes for all parties involved, most importantly, our guests.',
        },
        {
          q: "What's your favorite thing about your job?",
          a: 'My favorite thing about my job is being able to provide excellent service! This includes resolving any problems that may arise and making sure our guests are happy.',
        },
        {
          q: 'What would you like people to know about M|Catering?',
          a: 'M|Catering is a great place to work!',
        },
      ],
    },
    {
      image: '/assets/images/team/devon.jpg',
      id: 'devon-janks',
      name: 'Devon Janks',
      title: 'Director of Catering',
      faq: [
        {
          q: 'What type of events do you enjoy working?',
          a: 'I love all of the events we cater, specifically tailgates, weddings, corporate events, galas, and heritage months. Every event is special and unique in its own way.',
        },
        {
          q: 'What do you like about working for M|Catering?',
          a: 'I truly enjoy the team effort that I see from every member of this diverse community. Regardless of their skill level or background, everyone works together toward the same goal—exceeding client expectations and making every event memorable.',
        },
        {
          q: 'Tell us about the team?',
          a: "The team is extremely dedicated and hard working. They've been able to adapt so incredibly well these last few years and continue to grow and challenge themselves.",
        },
        {
          q: "What's your favorite thing about your job?",
          a: 'I love the ability to connect with people through food!',
        },
      ],
    },
    {
      image: '/assets/images/team/lacey.jpg',
      id: 'lacey-turner',
      name: 'Lacey Turner',
      title: 'Catering Manager',
      faq: [
        {
          q: 'What do you like about working for M|Catering?',
          a: 'M|Catering feels like one big family! My team is filled with hard working, dedicated individuals who are always willing to lend a hand during busy times.',
        },
        {
          q: 'Tell us about the team?',
          a: "Our team is composed of some of the hardest workers I have ever met. We spend countless hours together getting prepared for weddings, parties, and celebrations. I couldn't ask for a better team.",
        },
        {
          q: 'What type of events do you enjoy working?',
          a: 'I have fallen in love with working weddings! I love seeing our ballroom transform into a different space.',
        },
        {
          q: "What's your favorite thing about your job?",
          a: ' I love being able to work closely with students that come from different backgrounds and places. ',
        },
      ],
    },
    {
      image: '/assets/images/team/tyler.jpg',
      id: 'tyler-ryder',
      name: 'Tyler Ryder',
      title: 'Catering Manager',
      faq: [
        {
          q: 'What type of events do you enjoy working?',
          a: 'Weddings have always been some of my favorite events. Between the energy and music, they always put a smile on my face.',
        },
        {
          q: 'What do you like about working for M|Catering?',
          a: 'Working with and leading our student staff has always been one of my favorite things about the job. Though at times it can be challenging, I love the idea that in some way I am helping to mold and develop the next generation.',
        },
        {
          q: 'Tell us about the team?',
          a: "The team has been one of the biggest reasons I've been around for so long. Regardless of how much changes, somehow we always end up with some of the most caring and interesting people our community has to offer. (Not to mention hilarious and lots of fun!)",
        },
        {
          q: 'Describe a time when you went above and beyond for a customer/event?',
          a: "We put on a wedding in 2021 that I will never forget. An amazingly kind group had dozens of special requests. In order to navigate all the different obstacles, we spent lots of extra time planning and coordinating the event. But sure enough, the event went better than any of us had anticipated. I will never forget the look on both families' faces when they thanked me for making their event so special. I'm not sure going above and beyond ever felt so good!",
        },
      ],
    },
    {
      image: '/assets/images/team/warren.jpg',
      id: 'warren-roscoe',
      name: 'Warren Roscoe',
      title: 'Sous Chef',
      faq: [
        {
          q: 'Why do you enjoy being a chef?',
          a: 'I enjoy the challenging environment of the kitchen and the opportunity to learn and grow daily. This includes teaching and sharing my skills to make the team strong and successful.',
        },
        {
          q: 'Tell us about the menu at M|Catering.',
          a: 'The catering menu is a diverse, comprehensive menu that takes into account all of the different needs for our various events. We take pride in providing delicious and nutritious meals at every function.',
        },
        {
          q: "What's your signature dish?",
          a: 'My favorite thing to make is a good, hearty soup or sauce. I have been told my chili is one of my best creations. I also enjoy the challenge of making perfectly smoked dishes.',
        },
        {
          q: 'How do you bring sustainability to your work?',
          a: 'We do our best to minimize waste and keep ourselves accountable for quality, wholesome food preparation.',
        },
        {
          q: 'What has been the most memorable part of your career so far?',
          a: 'I really enjoyed working the omelet station for the Football Recruiting Breakfast.',
        },
      ],
    },
    {
      image: '/assets/images/team/luis.jpg',
      id: 'luis-lavieri',
      name: 'Luis Lavieri',
      title: 'Catering Administrative Assistant',
      faq: [
        {
          q: 'What do you like about working for M|Catering?',
          a: 'The people are amazing. When I joined M|Dining, I felt completely welcomed by the entire team.',
        },
        {
          q: 'Tell us about the team',
          a: 'Great culture shared from the top down. And, there almost seems to be a friendly competition to see who will work the hardest.',
        },
        {
          q: "What's your favorite thing about your job?",
          a: "Knowing that I'll be making an impact.",
        },
        {
          q: 'What would you like people to know about M|Catering?',
          a: "This is one of the hardest-working teams you will ever encounter. If we say we can't do something, it's because it can't be done.",
        },
        {
          q: 'How is M|Catering different or special?',
          a: 'For a large operation, there is an incredibly high level of communication. Everybody works toward a common goal.',
        },
      ],
    },
    {
      image: '/assets/images/team/pete.jpg',
      id: 'pete-simone',
      name: 'Pete Simone',
      title: 'Sous Chef',
      faq: [
        {
          q: 'Why do you enjoy being a chef?',
          a: 'Working as a chef gives you freedom and allows you to be more creative than just about any other career.',
        },
        {
          q: "What's your signature dish?",
          a: 'I really enjoy making Middle Eastern foods and working with those flavor profiles.',
        },
        {
          q: 'How do you bring sustainability to your work?',
          a: 'By sourcing responsibly with locally grown foods. We get vegetables from the U-M Campus Farm as well as MSC certified fish and proteins from local farms and distributors.',
        },
        {
          q: 'What has been the most memorable part of your career so far?',
          a: 'I will never forget serving 10,000 people for the U-M Bicentennial Celebration.',
        },
        {
          q: 'What kinds of events are your favorite to prepare food for?',
          a: 'Any kind of celebration event because we are part of creating an awesome memory for all in attendance',
        },
        {
          q: 'What would you like people to know about M|Catering?',
          a: 'We strive for excellence and are always working to be at the forefront of culinary trends.',
        },
      ],
    },
    {
      image: '/assets/images/team/brianna.jpg',
      id: 'brianna-westmoreland',
      name: 'Brianna Westmoreland',
      title: 'Assistant Catering Manager',
      faq: [
        {
          q: 'What type of events do you enjoy working?',
          a: "I love working reunions. All the guests seem ecstatic to see friends they haven't seen in years and it's so fun hearing their speeches.",
        },
        {
          q: 'Describe a time when you went above and beyond for a customer/event?',
          a: "Whenever I bartend at an event and a guest asks for a drink I've never heard of, I make sure to look up the ingredients and acquire additional items when necessary in order to make it.",
        },
        {
          q: 'How is M|Catering different or special?',
          a: 'Michigan Catering is special because every event is different and no one ends up doing the exact same thing every day. It keeps things upbeat and fun!',
        },
      ],
    },
    {
      image: '/assets/images/team/john-merucci.jpg',
      id: 'john-merucci',
      name: 'John Merucci',
      title: 'Senior Executive Chef',
      faq: [
        {
          q: 'Tell us about the menu at M|Catering.',
          a: "It's exciting, on-trend, and we provide a variety of wholesome and seasonal dishes by using locally sourced foods from local partners.",
        },
        {
          q: "What's your signature dish?",
          a: 'Chicken, Cherry, and Brie Strudel.',
        },
        {
          q: 'How do you bring sustainability to your work?',
          a: "By implementing root-to-stem, utilizing U-M's pantry and excellent recycling program, and composting.",
        },
        {
          q: 'What else would you like us to know about you, your work, or M|Catering?',
          a: 'We are student-focused and community-proud.',
        },
      ],
    },
    {
      image: '/assets/images/team/john-miller.jpg',
      id: 'john-miller',
      name: 'John Miller',
      title: 'Assistant Culinary Director',
      faq: [
        {
          q: 'Tell us about the menu at M|Catering.',
          a: 'You can expect to find items at all price points that cover many different culinary genres.',
        },
        {
          q: 'What has been the most memorable part of your career so far?',
          a: 'Competing in the IKA Culinary Olympics in Erfurt, Germany, where I won a gold medal; receiving the Prochef 2 Certification at the CIA in Hyde Park; also being inducted into the American Academy of Chefs.',
        },
        {
          q: 'What kinds of events are your favorite to prepare food for?',
          a: 'I enjoy preparing foods from a variety of cultures because it challenges me and gives me a chance to grow.',
        },
        {
          q: 'What would you like people to know about M|Catering?',
          a: 'We work to create menus that focus on the needs of the future and include global flavor profiles as well as health-conscious and sustainable processes.',
        },
        {
          q: 'How is M|Catering different or special?',
          a: 'The resources we have on campus give us the ability to stay on the forefront of trends and dietary preferences.',
        },
      ],
    },
    {
      image: '/assets/images/team/cory-godlewski.jpg',
      id: 'cory-godlewski',
      name: 'Cory Godlewski',
      title: 'Catering Manager, Michigan League',
      faq: [
        {
          q: 'How do you feel about your customers?',
          a: 'Everyone has their own individual story to tell. I truly enjoy meeting all kinds of people from all different backgrounds.',
        },
        {
          q: "What's your favorite thing about your job?",
          a: 'There is something special about walking through the doors of such a prestigious university that gives you a sense of pride.',
        },
        {
          q: 'What has been the most memorable part of your career so far?',
          a: 'I spent the last 12 years working in corporate catering in Chicago—bringing my knowledge back to Michigan has been a full circle moment as I waited tables in downtown Ann Arbor back in college.',
        },
        {
          q: 'What would you like people to know about M|Catering?',
          a: 'We really are one huge family that looks out for one another.',
        },
      ],
    },
    {
      image: '/assets/images/team/gerald-linares.jpg',
      id: 'gerald-linares',
      name: 'Gerald Linares',
      title: 'Assistant Catering Manager',
      faq: [
        {
          q: 'What do you like about working for M|Catering?',
          a: 'The food! The chefs are geniuses in the kitchen.',
        },
        {
          q: 'Tell us about the team!',
          a: 'My team has so much wisdom to share and jokes to tell. I learn so much from them every day.',
        },
        {
          q: 'How do you feel about your customers?',
          a: 'They always have such great ideas for events, with a clear vision for us to bring to life.',
        },
        {
          q: 'Describe a time you went above and beyond for a customer/event?',
          a: 'After a beautiful wedding, I realized the bride left her veil at the venue so I drove it over to her house straight away.',
        },
      ],
    },
    {
      image: '/assets/images/team/tommy-demers.jpg',
      id: 'tommy-demers',
      name: 'Tommy Demers',
      title: 'Sous Chef',
      faq: [
        {
          q: 'Why do you enjoy being a chef?',
          a: 'I enjoy the leadership aspect of guiding a team and fully engaging in our daily operations to provide fresh sustainable food for the community.',
        },
        {
          q: 'Tell us about the menu at Michigan Catering.',
          a: 'Our diverse menu offers a great variety from many regions and cultures, and it showcases our abilities and skills here at the university.',
        },
        {
          q: "What's your signature dish?",
          a: 'Beef Bulgogi and Cucumber Salad.',
        },
        {
          q: 'How do you bring sustainability to your work?',
          a: 'By working with our team to ensure we are keeping waste to a minimum and properly composting and recycling during production.',
        },
      ],
    },
    {
      image: '/assets/images/team/jeremy-henrick.jpg',
      id: 'jeremy-hendrick',
      name: 'Jeremy Hendrick',
      title: 'Catering Captain',
      faq: [
        {
          q: 'What type of events do you enjoy working?',
          a: 'Golf Outings, Getting the opportunity to have genuine conversations with our guests and hear the excitement in their voices about their jobs, daily life, or love for golf never gets old.',
        },
        {
          q: 'What do you like about working for M|Catering?',
          a: 'Being able to bring a bit of joy to our guests through the thing we all love, food!',
        },
        {
          q: 'Tell us about the team?',
          a: 'Since day one, everyone I have come in contact with has been beyond helpful with my acclimation to my position. Allowing me to feel comfortable and learn much about the position and department stress free.',
        },
        {
          q: "What's your favorite thing about your job?",
          a: 'That there is still so much for me to learn about what M|Dining has to offer. As well as how vast the options are of items we offer and how talented our Chefs/Cooks are with preparing them.',
        },
        {
          q: 'What would you like people to know about M|Catering?',
          a: 'That we are adamant about being able to accommodate most food related concerns any one may have so that you can have an event on campus knowing that our food will be top notch and of high quality.',
        },
      ],
    },
    {
      image: '/assets/images/team/emily-schenk.jpg',
      id: 'emily-schenk',
      name: 'Emily Schenk',
      title: 'Assistant Catering Manager',
      faq: [
        {
          q: 'How do you feel about your customers?',
          a: "It's exciting to work with a diverse set of events ranging from community events, private events, and internal events throughout the University.",
        },
        {
          q: 'Describe a time when you went above and beyond for a customer/event?',
          a: 'One of the first weddings I had assisted with set-up at their venue had their wedding planner quit on them last minute. They needed extra assistance setting up linens and their flowers. I helped them so that the bride could stop setting up and try to relax and enjoy getting ready with her bridal party. The family had brought some items for a memory table for her grandfather who had passed away. I used some extra flowers and votive candles and made a really nice display to honor him. When the bride saw everything I had done she started crying and hugged me because it was even better than she expected it would be.',
        },
        {
          q: "What's your favorite thing about your job?",
          a: "I love being a part of someone's special day. Whether it be a small meeting or a 300 person wedding, I enjoy helping and ensuring the clients' events run smoothly.",
        },
        {
          q: 'What would you like people to know about M|Catering',
          a: 'We do so many more events than you could imagine. We work with student groups, Bat Mitzvahs, veterans groups and so many more. We have the capacity and ability to run 7 large events at once as well as many smaller breakout rooms. The possibilities are endless of what this team can accomplish.',
        },
        {
          q: 'What else would you like us to know about you, your work or M|Catering?',
          a: 'I have worked in events for nearly a decade. There is no industry quite like hospitality. I enjoy the busy days. I love to stay active by playing tennis and pickleball. I am an avid reader and love doing anything that requires any creativity or crafting.',
        },
      ],
    },
    {
      image: '/assets/images/team/deja-wilson.jpg',
      id: 'deja-wilson',
      name: 'Deja Wilson',
      title: 'Catering Captain',
      faq: [
        {
          q: 'Tell us about the team?',
          a: 'Our catering team is full of creative chefs, diverse student staff, and an excellent management team that is willing to go the extra mile for our guests.',
        },
        {
          q: "What's your favorite thing about your job?",
          a: "I love meeting new students and being able to guide them and help them grow. I've been able to watch a lot of the students step up to lead their peers and become great role models for incoming student employees.",
        },
        {
          q: 'What else would you like us to know about you, your work or M|Catering?',
          a: 'I am very detail oriented when it comes to day to day preparation and making sure our students are prepared and confident to service an event.',
        },
      ],
    },
    {
      image: '/assets/images/team/johnny-schulze.jpg',
      id: 'johnny-schulze',
      name: 'Johnny Schulze',
      title: 'Senior Executive Chef',
      faq: [
        {
          q: 'Why do you enjoy being a chef?',
          a: 'I enjoy experiencing all the diverse cultural flavors and foods from other cuisines that I am not familiar with. Here at M|Catering I have a great opportunity to experience this.',
        },
        {
          q: 'Tell us about the menu at Michigan Catering.',
          a: 'The menu is seasonal and both simple and sophisticated. The menu covers wide-ranging, culturally diverse cuisines that have piqued my interest in these other cuisines.',
        },
        {
          q: 'What has been the most memorable part of your career so far?',
          a: 'It was owning my own small business and working with my two teenage children.  I have fond memories spending quality time with them helping me run a successful small business.',
        },
        {
          q: 'What kinds of events are your favorite to prepare food for?',
          a: 'I have to say celebrations like weddings and anniversaries are my favorite. Knowing that my hard work helped families have a great time sharing a meal together is very fulfilling.',
        },
        {
          q: 'How is M|Catering different or special?',
          a: 'We cook and accommodate for many diverse and unique cuisines for our guests.  Our team is equally as diverse and experienced so that we can replicate family recipes whenever possible.',
        },
      ],
    },
    {
      image: '/assets/images/team/justin-lucas.jpg',
      id: 'justin-lucas',
      name: 'Justin Lucas',
      title: 'Senior Executive Chef',
      faq: [
        {
          q: 'Why do you enjoy being a chef?',
          a: 'Knowing that each day will be different.',
        },
        {
          q: 'What’s your signature dish?',
          a: 'Charcuterie.',
        },
        {
          q: 'How do you bring sustainability to your work?',
          a: 'I have always tried to use local ingredients and utilize them as much as possible.',
        },
        {
          q: 'What has been the most memorable part of your career so far?',
          a: 'Cooking at the James Beard House.',
        },
        {
          q: 'What would you like people to know about M|Catering?',
          a: 'All the hard work that goes on behind the scenes.',
        },
      ]
    }
  ];
}
